import { render, staticRenderFns } from "./ChatUserCard.vue?vue&type=template&id=3617768d&scoped=true"
import script from "./ChatUserCard.vue?vue&type=script&lang=js"
export * from "./ChatUserCard.vue?vue&type=script&lang=js"
import style0 from "./ChatUserCard.vue?vue&type=style&index=0&id=3617768d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617768d",
  null
  
)

export default component.exports